import BannerScreen from './containers/bannerScreen'

export {default as BannerScreenLayout} from './components/bannerScreenLayout'

export default BannerScreen
